import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }

    transform(html: string): SafeHtml {
        // This tells Angular: "I trust this HTML, do not strip attributes like data-field"
        if (!html) return '';
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
